import { render, staticRenderFns } from "./fukidashiComment.vue?vue&type=template&id=08c5ed80&scoped=true"
import script from "./fukidashiComment.vue?vue&type=script&lang=js"
export * from "./fukidashiComment.vue?vue&type=script&lang=js"
import style0 from "./fukidashiComment.vue?vue&type=style&index=0&id=08c5ed80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c5ed80",
  null
  
)

export default component.exports